export interface User {
  id: string
  email: string
  name: string
  profile_pic_url: string
  org_id: string
  date_created: string
  role: UserRole
  is_corporate: boolean
}

export enum UserRole {
  ADMIN = 'admin',
  MEMBER = 'member'
}

export enum UserInviteStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted'
}
